








































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import WalletModel from '@/model/WalletModel'
import NemUtil from '@/util/NemUtil'

@Component
export default class Wallet extends Vue {
    private isLoading: boolean = false
    private wallet: WalletModel = new WalletModel()
    private qrSize: number = 200
    private toAmount: number = 0
    private toAddr: string = ''
    private message: string = ''
    private qrJson: string = ''
    private validation: any[] = []
    private resultMessage: string = ''
    private rules: any = {
      senderAddrLimit: (value: string) => (value && (value.length === 46 || value.length === 40)) || '送金先アドレス(-除く)は40文字です。',
      senderAddrInput: (value: string) => {
        const pattern = /^[a-zA-Z0-9-]+$/
        return pattern.test(value) || '送金先の入力が不正です'
      },
      amountLimit: (value: number) => (value >= 0) || '数量を入力してください',
      amountInput: (value: string) => {
        const pattern = /^[0-9.]+$/
        return (pattern.test(value) && !isNaN(Number(value))) || '数量の入力が不正です'
      },
      messageRules: (value: string) => (value.length <= 1024) || 'メッセージの最大文字数が超えています。',
    }

  @Watch('wallet.address')
  private onValueChange(newValue: string, oldValue: string): void {
    this.qrJson = NemUtil.getQRcodeJson(2, 2, 'nem-wallet', newValue, 0, '')
  }

  private mounted() {
    Vue.prototype.$toast('Hello NEM wallet')
  }

  private async getAccount() {
    this.isLoading = true
    await this.wallet.getAccount()
    this.isLoading = false
  }

  private async tapSend() {
    this.resultMessage = ''
    if (this.isValidation() === true) {
      this.isLoading = true
      try {
        const result = await this.wallet.sendNem(this.toAddr, this.toAmount, this.message)
        const message = result.message + ': \n' + result.transactionHash.data
        if (result.message === 'SUCCESS') {
          this.resultMessage = 'SUCCESS<br><br>TransactionHash<br>' + result.transactionHash.data
          this.clear()
        } else {
          this.resultMessage = result.message
        }
        Vue.prototype.$toast(message)
      } catch (error) {
        this.resultMessage = error
        Vue.prototype.$toast(error)
      }
      this.isLoading = false
    }
  }

  private isValidation(): boolean {
    this.validation = []
    this.validation.push(this.rules.senderAddrLimit(this.toAddr))
    this.validation.push(this.rules.senderAddrInput(this.toAddr))
    this.validation.push(this.rules.amountLimit(this.toAmount))
    this.validation.push(this.rules.amountInput(`${this.toAmount}`))
    this.validation.push(this.rules.messageRules(this.message))
    const error: any[] = this.validation.filter((obj: any) => obj !== true )
    return (error.length === 0) ? true : false
  }

  private clear() {
    this.toAmount = 0
    this.toAddr = ''
    this.message = ''
  }
}
